import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-right-circle-24", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "matrix(-1 0 0 1 21 3)" },
        React.createElement("circle", { cx: 9, cy: 9, r: 9, fill: "currentColor", fillOpacity: 0.15 }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M8 6 5 9l3 3M6.5 9h7" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
